
//import ProductMenu1 from "../components/ProductMenu1";
import { useSelector } from "react-redux";
import { useState } from "react";
import { withRouter, useRouteMatch,useLocation } from "react-router-dom";
import BottomNavigation from "../components/BottomNavigation";
import { exportLogo, randomColors, scaleImage } from "../provider/functions";
import Sliders from "../components/Slider";
import { VariantChildDiv, VariantContainerDiv } from "../components/motion/AllMotions";
import { useEffect } from "react";
export default withRouter(HomePage);
function HomePage({ history }) {
  let match = useRouteMatch();
  const serverReducer = useSelector((state) => state.server.data);
  const [data,setData] = useState([]);
  //const loading = useSelector((state) => state.server.loading);
  // const productsReducer = useSelector((state) =>
  //   state.products.data.filter((v) => v.active)
  // );
  const categoriesReducer = useSelector((state) => [...state.categories.data]);
  useEffect(()=>{
    const mothers = categoriesReducer.filter(v=>!v.mother);
    if(match.params.categoryId){
      const subs = categoriesReducer.filter(v=>v.mother==match.params.categoryId);
      setData(subs);
      return;
    }
    setData(mothers);
  },[match.params.categoryId])
  const languageRedux = useSelector((state) => state.language);
  const mostSeller = useSelector((state) => state.products.mostSeller);
  const language = languageRedux.selected;
 
  
  function clickCategory(category) {
    const subs = categoriesReducer.filter(v=>v.mother==category.id);
    if(subs.length>0){
       history.push((match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/menu/"+category.id);
    }else{
      history.push((match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/categories/",category);
    }
  }
  //const [selectedCategorie, setselectedCategorie] = useState("all");
  return (
    <div className="rp-app rp-home">
      <div className="container-fluid">
        <div className="rp-page-body " style={{marginBottom:100}}>
          <div className="rp-page-header" style={{backgroundImage:"linear-gradient(205deg, "+serverReducer.bgcolor2+", "+serverReducer.bgcolor1+")"}}>
            <div className="rp-hh-content flex-between">
              <div className="area">
                <a onClick={()=>{
                  history.length>1?history.goBack():
                  history.push((match.params.server?"/"+match.params.server:"")+"/"+match.params.table)
                  }} className="link">
                  <i className="fa fa-arrow-left" />
                </a>
              </div>
              <div className="area">
                <div className="logo">
                  <img src={serverReducer.image ? scaleImage(serverReducer.image) :exportLogo(serverReducer.host)} alt="Logo" />
                </div>
              </div>
              <div className="area" style={{minWidth:40}}>
              </div>
            </div>
          </div>
          <VariantContainerDiv className="row">
           <Sliders style={{marginBottom:10,marginTop:10}}/>
          { (!match.params.categoryId && mostSeller.length>0) ? <div className="col-6 col-md-4 col-lg-3 col-xl-2" >
              <a onClick={()=>history.push((match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/categories/")} className="link-unstyled">
                <div className="rp-category-box">
                  <img src={scaleImage(mostSeller[0].image)} style={{backgroundColor:'black'}} />
                  <div className="content">
                    <h2 className="name">  ⭐ {String(languageRedux.data?.cok_satanlar).toUpperCase()} ⭐</h2>
                  </div>
                </div>
              </a>
            </div>:""}
           
            {data.map((category,index)=><VariantChildDiv className="col-6 col-md-4 col-lg-3 col-xl-2" key={index}>
              <a onClick={()=>clickCategory(category)} className="link-unstyled">
                <div className="rp-category-box">
                  <img src={scaleImage(category.image)} style={{backgroundColor:category.image?'white':randomColors[index]}} loading="lazy" />
                  <div className="content">
                    <h2 className="name">  {(category.languages && category.languages[language]) ?  category.languages[language].title : (category.title)}</h2>
                  </div>
                </div>
              </a>
            </VariantChildDiv>)}
          
          </VariantContainerDiv>
        </div>
        <BottomNavigation />
      </div>
    

    </div>
  );
}